import { createPortal } from 'react-dom';
import { LuTriangleAlert, LuX } from 'react-icons/lu';

import useErrorModal from './error-modal.controller';

const ID = 'error-modal';
export interface ErrorModalProps {
    show?: boolean;
    title?: string | React.ReactNode;
    message?: string | React.ReactNode;
    onClose?: () => void;
}

const ErrorModal = (props: ErrorModalProps) => {
    const viewProps = useErrorModal(props);

    if (!props.show) {
        return null;
    }

    const root = document.getElementById('root');
    if (!root) return null;

    return createPortal(
        <div
            id={ID}
            className='fixed inset-0 z-1000 flex items-center justify-center'
            data-node-id='3428:4379'>
            {/* Backdrop */}
            <div
                className='absolute inset-0 bg-stone-950/40'
                data-name='Background'
                data-node-id='3428:4406'
            />

            {/* Modal */}
            <div
                className='bg-background-surface border-border-default relative z-10 flex w-96 flex-col items-center justify-center gap-6 overflow-hidden rounded-2xl border p-6'
                data-name='Modal'
                data-node-id='3428:4407'>
                {/* Modal Header */}
                <div className='flex w-full flex-col items-start gap-0 self-stretch'>
                    <div className='flex w-full items-center justify-between self-stretch'>
                        <span
                            className='flex flex-row items-center gap-2'
                            data-name='Title'
                            data-node-id='3428:4410'>
                            {!props.message && (
                                <div
                                    className='bg-status-danger flex size-10 items-center justify-center rounded-full'
                                    data-name='Icon Container'
                                    data-node-id='3428:4408'>
                                    <LuTriangleAlert className='text-background-surface size-6' />
                                </div>
                            )}
                            <p className='text-foreground-default text-xl font-semibold'>{props.title || 'Error'}</p>
                        </span>
                        <button
                            disabled={!props.onClose}
                            className='text-foreground-default disabled:text-brand-disabled relative flex size-6 cursor-pointer items-center justify-center overflow-hidden transition-colors'
                            onClick={() => props.onClose && props.onClose()}
                            data-name='Icon Container'
                            data-node-id='3428:4411'>
                            <LuX className='size-full' />
                        </button>
                    </div>
                </div>

                {props.message && (
                    <div
                        className='flex flex-col items-center justify-center gap-2'
                        data-name='Content'
                        data-node-id='3428:4409'>
                        <div
                            className='bg-status-danger flex size-10 items-center justify-center rounded-full'
                            data-name='Icon Container'
                            data-node-id='3428:4408'>
                            <LuTriangleAlert className='text-background-surface size-6' />
                        </div>
                        {/* Message */}
                        <p className='text-foreground-default min-w-full text-center text-base font-medium whitespace-pre-wrap'>{props.message}</p>
                    </div>
                )}
            </div>
        </div>,
        root
    );
};

export default ErrorModal;
